import { normalizeSliderTimeValue } from "@/components/AgendaFilters/utils/getSliderOptions";

import { AgendaQueryInputs } from "../atoms/agendaQueryInputs";

/** All Day must not constrain availability to potentially incomplete slot-derived slider bounds. */
export const getAvailabilityTimeBounds = (
  times: AgendaQueryInputs["times"],
  controlStartTime?: string | null,
  controlEndTime?: string | null
) => {
  const startTime = normalizeSliderTimeValue(times?.timeGTE);
  const endTime = normalizeSliderTimeValue(times?.timeLTE);
  const isAllDay =
    startTime &&
    endTime &&
    startTime === normalizeSliderTimeValue(controlStartTime) &&
    endTime === normalizeSliderTimeValue(controlEndTime);

  return {
    startTime: isAllDay ? undefined : startTime,
    endTime: isAllDay ? undefined : endTime,
  };
};
